/*
 * @Description: 网站首页管理-网站视频服务接口
 * @Author: zml
 * @Date: 2023-07-27 11:04:59
 * @LastEditors: zml
 * @LastEditTime: 2023-07-27 11:05:37
 */

import request from '@/utils/request'

/**
 * 获取网站视频分类列表
 * @author: zml
 */
 export function VideoGetCategoryList(data) {
  return request({
    url: '/front/Video/GetCategoryList',
    method: 'post',
    data
  })
}